import styles from "./CapabilityCards.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Heading + intro + a wrapping band of BORDERED icon+label cards.
 * Built for Figma `4673-18490` (chemical-toll "Your Chemical Toll Manufacturing
 * Partner in …") / mobile `5597-7942`.
 *
 * Deliberately separate from `PartnerBand`, which renders the visually different
 * essential-oil treatment (borderless rows, 40px indent on later columns,
 * left-aligned). The two disagree on layout engine, item chrome, alignment, icon
 * size and type scale, so they are kept as two components rather than one with a
 * large override block — that also means this file cannot regress the three live
 * essential-oil pages, since they share no CSS.
 *
 * Fully data-driven and reusable by the other supplier types:
 * @param {string}  heading
 * @param {string|string[]} body    intro paragraph(s)
 * @param {Array}   items           `{ icon, title }`; card count = items.length
 * @param {number}  columns         cards per row on desktop (default 4)
 * @param {string}  surface         `dark` (default) | `light` | `grey`
 * @param {string}  align           `center` (default) | `left` — desktop only;
 *                                  every Figma mobile frame left-aligns.
 */
export default function CapabilityCards({
  heading,
  body,
  items = [],
  columns = 4,
  surface = "dark",
  align = "center",
}) {
  if (!items.length && !heading) return null;
  const paras = Array.isArray(body) ? body : body ? [body] : [];

  return (
    <section
      className={`${styles.section} ${styles[surface] || ""} ${
        styles[`align-${align}`] || ""
      }`}
    >
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {paras.map((p, i) => (
          <p className={styles.para} key={i}>
            {p}
          </p>
        ))}

        {items.length > 0 && (
          <ul className={styles.list} style={{ "--cols": columns }}>
            {items.map((item, i) => (
              <li className={styles.card} key={i}>
                <span className={styles.iconWrap}>
                  <img src={resolveIcon(item.icon)} alt="" aria-hidden="true" />
                </span>
                <span className={styles.label}>{item.title}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
